import { z } from 'zod';

// Site schemas
export const siteSchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  name: z.string().min(1, 'Site name is required'),
  subdomain: z.string().optional(),
  customDomain: z.string().optional(),
  homePageId: z.string().uuid().nullable().optional(),
  theme: z.string().optional().default('standard'),
  faviconUrl: z.string().optional(),
  isPublished: z.boolean().default(false),
  isLandingPage: z.boolean().optional().default(false),
  publishedAt: z.string().datetime().optional(),
  // Site-level SEO settings
  seoTitle: z.string().optional(),
  seoDescription: z.string().optional(),
  seoKeywords: z.string().optional(),
  ogTitle: z.string().optional(),
  ogDescription: z.string().optional(),
  ogImage: z.string().optional(),
  // Analytics and tracking
  googleAnalyticsId: z.string().optional(),
  googleTagManagerId: z.string().optional(),
  // Meta tracking
  metaPixelId: z.string().optional(),
  // Meta CAPI - token is write-only, only hasMetaAccessToken is returned
  hasMetaAccessToken: z.boolean().optional(),
  metaTestEventCode: z.string().optional(),
  // Native analytics
  nativeAnalyticsEnabled: z.boolean().optional().default(true),
  // Custom scripts
  customHeadScripts: z.string().optional(),
  customBodyScripts: z.string().optional(),
  // Privacy banner (GDPR compliance)
  privacyBannerEnabled: z.boolean().optional().default(false),
  privacyBannerMessage: z.string().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

export const createSiteSchema = z.object({
  name: z.string().min(1, 'Site name is required').max(100, 'Site name is too long'),
  theme: z.string().optional().default('standard'),
});

export const publishSiteSchema = z.object({
  isPublished: z.boolean(),
});

// Type exports
export type Site = z.infer<typeof siteSchema>;
export type CreateSiteRequest = z.infer<typeof createSiteSchema>;
export type PublishSiteRequest = z.infer<typeof publishSiteSchema>;
